
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import TermItemView from './TermItemView';
import _ from 'underscore';

import islexHelper from './../islexHelper';

class TermView extends Component {
	render() {
		let dataItem = this.props.data;

		let rnumEl;

		if (dataItem.rnum && dataItem.rnum > 0) {
			rnumEl = <small>{dataItem.rnum} </small>
		}

		let osambOccurred = false;

		return (
			<div className="dict-view">

				<div className="dict-word">
				{
					rnumEl
				}
				{dataItem.fletta} <span className="word-class">{islexHelper.formatOfl(dataItem.ofl)}</span></div>
				{
					dataItem.stuttbeyg && dataItem.stuttbeyg != '' &&
					<div className="dict-info alert alert-info">{dataItem.stuttbeyg}</div>
				}
				{
					dataItem.items && dataItem.items.length > 0 &&
					dataItem.items.map(function(item, index) {
						let extraHeading;

						if (item.teg == 'OSAMB' && !osambOccurred) {
							extraHeading = 'Orðasambönd:';
							osambOccurred = true;
						}

						let termItemView = <TermItemView key={index} firstLevel={true} lang={this.props.lang} item={item} extraHeading={extraHeading} />;

						return termItemView;
					}.bind(this))
				}

			</div>
		);
	}
}

export default withRouter(TermView);
